<!--
  Side view of the agent object (cp.ProvisionAgent).
  Compact shape after bm-billing-area-side.component.html: master data + balances without
  the wide tables; further navItems are also rendered on request (sideNavItem).
  "Kennzahlen" is the default navItem (business rule 1), so it leads the chain here as well; the
  KPI tiles are compact enough for the narrow panel. The trailing @else keeps the historical
  balance + master-data fallback for anything that resolves to no navItem at all.
-->
@if (initialized && dto) {

    <div class="cp-provision-agent-side mt-3"
         [class.cp-provision-agent-side--workbench]="activeNavigationItem?.action == 'contractAgents'">

        @if (activeNavigationItem?.action == 'kpi') {
            <cp-provision-agent-kpi
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-kpi>
        } @else if (activeNavigationItem?.action == 'configuration') {
            <!-- Dieselbe Komponente wie in der Vollansicht. Sie trägt die schmale Spalte, weil sie
                 sich datengetrieben verengt: gerendert werden nur die BELEGTEN Dimensionsspalten
                 (heute vier von dreizehn), und die Nullkombinationen sind zugeklappt. Die breiten
                 Angaben — Vererbungspfad, Gültigkeiten, Gruppenvergleich — stehen ohnehin erst in
                 der Zeilenaufklappung. -->
            <cp-provision-agent-configuration
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-configuration>
        } @else if (activeNavigationItem?.action == 'account') {
            <!-- FD-3: the side view keeps the compact read-only balance widget — the full account
                 statement (running balance, filters, booking dialogs) is a full-view pane only. -->
            <cp-provision-agent-balance
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-balance>
        } @else if (activeNavigationItem?.action == 'contractAgents') {
            <!-- List-only here (user decision): the side view reaches the user through the object
                 navigation p-drawer, and a two-pane workbench — filter bar plus a thirteen-column
                 table beside a complete Provisionssatz OBC, at minimum pane widths of 30 % and 25 %
                 — is not operable at drawer width. The route to the detail view stays "im neuen
                 Fenster öffnen", which switches the OBC to uiMode 'full' and brings the workbench. -->
            <cp-provision-agent-contract-agents
                    [provisionAgentId]="objectIdentifier.objectId"
                    [provisionAgentName]="dto?.name"
                    [canAgentChange]="canAgentChange"
                    [allowDetailPane]="false">
            </cp-provision-agent-contract-agents>
        } @else if (activeNavigationItem?.action == 'payouts') {
            <cp-provision-agent-payouts
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-payouts>
        } @else if (activeNavigationItem?.action == 'statements') {
            @if (!canAgentStatement) {
                <p-message severity="warn" styleClass="w-full mb-3">
                    <span class="text-sm">
                        Neuausstellung gesperrt: Der Server hat das Recht „cp_agentStatement“ für Sie verweigert.
                    </span>
                </p-message>
            }
            <cp-provision-agent-statements #statementsList
                    [provisionAgentId]="objectIdentifier.objectId"
                    [canReissue]="canAgentStatement"
                    (reissueRequested)="handleReissueRequested($event)">
            </cp-provision-agent-statements>
        } @else if (activeNavigationItem?.action == 'groups') {
            <cp-provision-agent-groups
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-groups>
        } @else if (activeNavigationItem?.action == 'reserveCoverage') {
            <cp-provision-agent-reserve-coverage
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-reserve-coverage>
        } @else {
            <cp-provision-agent-balance
                    [provisionAgentId]="objectIdentifier.objectId">
            </cp-provision-agent-balance>

            <div class="mt-3">
                <cp-provision-agent-base-data
                        [provisionAgentId]="objectIdentifier.objectId">
                </cp-provision-agent-base-data>
            </div>
        }

    </div>

    <cp-provision-agent-statement-reissue-dialog
            [(visible)]="reissueDialogVisible"
            [statement]="reissueStatement"
            (reissued)="handleStatementReissued()"
            (onForbidden)="handleStatementForbidden()">
    </cp-provision-agent-statement-reissue-dialog>

}
